import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Field from '../../../../../../../../../../1stlog-ui/src/components/Field'
import TimePicker from '../../../../../../../../../../1stlog-ui/src/components/TimePicker'

const Wrapper = styled.div``

const FixedAppointment = (props) => {
  const {} = props

  return (
    <Wrapper>
      <div className="text-muted">Früheste Abholung/Zustellung</div>
      <div className="mt-1">
        <Field name="fixedAppointment">
          <TimePicker />
        </Field>
      </div>
    </Wrapper>
  )
}

export default FixedAppointment
